import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
export interface UmraSupplierProperties {
  supplierId: number;
  supplierName: string;
  supplierLetter: string;
  supplierType: string;
  isActive: boolean;
  isEnabled: boolean;
  createdDate: Date;
  markupOnSupplier: number;
  discountOnSupplier: number;
}

@Injectable({ providedIn: 'root' })
export class UmraSupplierService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient, private ngZone: NgZone) { }

  getAll(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/UmraSupplierManagement/get-all`
    );
  }

  get(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/UmraSupplierManagement/Get/${id}`);
  }

  save(supplier: UmraSupplierProperties): Observable<any> {
    return supplier.supplierId
      ? this.http.put<any>(`${this.baseUrl}/UmraSupplierManagement/${supplier.supplierId}/update-supplier/`, supplier)
      : this.http.post<any>(`${this.baseUrl}/UmraSupplierManagement/save-supplier`, supplier);
  }

  toggleEnabled(id: number, isEnabled: boolean): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/UmraSupplierManagement/${id}/toggle-enabled`, { isEnabled });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/UmraSupplierManagement/${id}/deactivate-supplier`);
  }

}
